import styled from 'styled-components';

export const AnuncioContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 30px 0;

    @media (max-width: 768px) {
        flex-direction: column;
        min-height: 0;
    }
`;

export const AnuncioTitulo = styled.h1`
    font-size: 31px;

    margin-bottom: 10px;
`;

export const AnuncioDetalhadoContainer = styled.div`
    width: 57%;

    @media (max-width: 768px) {
        width: 100%;

        h1 {
            font-size: 1.6rem;
        }
    }

    .valor {
        font-size: 31px;
    }

    h3 {
        margin: 0;
        display: block;
        padding: 12px 0;
        font-weight: bold;
    }
`;

export const DetalhesImovelBox = styled.div`
    width: 60%;
    margin-bottom: 30px;

    @media (max-width: 768px) {
        width: 100%;
        margin-bottom: 0;
    }
`;

export const TextoSetor = styled.p`
    margin: 0;
    margin-bottom: 5px;
    color: #626262;
    font-size: 1.2rem;
`;

export const TextoCodigoAnuncio = styled.p`
    color: #626262;
    font-size: 0.9rem;
    margin: 0;
    margin-bottom: 20px;
`;

export const BoxInfoImovel = styled.div`
    font-size: 1rem;
    margin-bottom: 8%;
    line-height: 1.63;

    small {
        font-size: 1rem;
    }
`;

export const BoxFotosVideos = styled.div`
    display: flex;
    margin: 0 10px 0 0;
    flex-direction: row;
    width: 50%;

    @media (max-width: 768px) {
        width: 70%;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    margin-bottom: 10px;

    @media (max-width: 768px) {
        margin-bottom: 20px;
    }
`;
